import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";

import CheckboxGroup from "components/InputsField/formikInputs/CheckboxGroup";
import SearchForm from "components/FreightComponents/SearchForm";
import Title from "components/common/Layout/Title";
import FormRow from "components/common/Layout/FormRow";
import { ERROR_PLACE } from "components/InputsField/InputError";

import FormikCheckboxField from "components/InputsField/formikInputs/FormikCheckboxField";
import FormikDateInput from "components/InputsField/formikInputs/FormikDateField";
import AsyncSelect from "components/InputsField/formikInputs/AsyncSelect";
import FormikTextField from "components/InputsField/formikInputs/FormikTextField";
import { numberInput, floatNormalize9999, input50 } from "components/InputsField/inputFormats";


import styles from "./styles.module.scss";
import { UTILS } from "endpointsConst";
const SearchExchange = ({ isOpen }) => {
    const lang = useSelector((state) => state.settings.lang);
    const { values } = useFormikContext();
    const { t } = useTranslation();

    return (
        <>
            <SearchForm />
            <FormRow withMargin>
                <FormRow withSpace withLine>
                    <FormikDateInput
                        name="available_from"
                        label={t("transportSearch.date_uploading")}
                        placeholderText={t("cargoSearch.size_field.grey_from")}
                        minDate={new Date(new Date().setHours(0, 0, 0, 0))}
                        maxDate={values.available_to ? new Date(values.available_to) : null}
                        errorMode={ERROR_PLACE.topRight}
                    />
                    <FormikDateInput
                        name="available_to"
                        label={t("transportSearch.date_unloading")}
                        placeholderText={t("cargoSearch.size_field.grey_till")}
                        minDate={
                            values.available_from ? new Date(values.available_from) : new Date(Date.now())
                        }
                        errorMode={ERROR_PLACE.topRight}
                    />
                </FormRow>
                <FormRow withSpace>
                    <AsyncSelect
                        url={`${UTILS}/transport-bodytypes/?lang=${lang}`}
                        label={t("transportSearch.body")}
                        name="transport_bodytype_ids"
                        isClearable={true}
                        sort
                        isMulti
                    />
                    <FormikTextField
                        name="carrying_capacity"
                        label={t("transportSearch.weight")}
                        maxLength="6"
                        format={numberInput}
                        normalize={floatNormalize9999}
                    />
                </FormRow>
            </FormRow>
            {isOpen && (
                <>
                    <Title withMargin>{t("transportSearch.size_search_box.heading")}</Title>
                    <FormRow>
                        <FormRow withSpace>
                            <FormikTextField
                                name="width"
                                maxLength="4"
                                label={t("transportSearch.size_search_box.width")}
                                format={input50}
                            />
                            <FormikTextField
                                name="height"
                                maxLength="4"
                                label={t("transportSearch.size_search_box.height")}
                                format={input50}
                            />
                        </FormRow>
                        <FormRow withSpace>
                            <FormikTextField
                                name="length"
                                maxLength="4"
                                label={t("transportSearch.size_search_box.length")}
                                format={input50}
                            />
                            <FormikTextField
                                name="volume"
                                maxLength="4"
                                label={t("transportSearch.size_search_box.volume")}
                                format={input50}
                            />
                        </FormRow>
                    </FormRow>
                    <FormRow withMargin>
                        <div className={styles.checkboxRow}>
                            <CheckboxGroup
                                checkboxes={[
                                    <FormikCheckboxField
                                        name="partial_load"
                                        id="partialLoad"
                                        label={
                                            <>
                                                {t("transportSearch.size_search_box.backloading")}
                                                <span className="info__logo" />
                                            </>
                                        }
                                    />,
                                    <FormikCheckboxField
                                        name="dont_show_without_dimensions"
                                        id="dont_show_without_dimensions"
                                        label={
                                            <>
                                                {t("transportSearch.size_search_box.no_size_box")}
                                                <span className="info__logo" />
                                            </>
                                        }
                                    />,
                                ]}
                            />
                        </div>
                    </FormRow>
                    <Title withMargin>{t("cargoSearch.additional_field.heading")}</Title>
                    <FormRow withMargin>
                        <AsyncSelect
                            url={`${UTILS}/loadingTypes/?lang=${lang}`}
                            label={t("transportSearch.uploading")}
                            name="transports_loading_types"
                            isClearable={true}
                            isMulti
                        />
                        <AsyncSelect
                            url={`${UTILS}/paymentRateTypes/?lang=${lang}`}
                            label={t("transportSearch.type_payment")}
                            name="payment_rate_type_id"
                            isClearable={true}
                        />
                    </FormRow>
                    <FormRow withMargin>
                        <div className={styles.checkboxRow}>
                            <CheckboxGroup
                                checkboxes={[
                                    <FormikCheckboxField
                                        name="without_prepayment"
                                        id="without_prepayment"
                                        label={
                                            <>
                                                {t("transportSearch.without_prepayment")}
                                                <span className="info__logo" />
                                            </>
                                        }
                                    />,
                                    <FormikCheckboxField
                                        name="with_documents"
                                        id="with_documents"
                                        label={
                                            <>
                                                {t("transportSearch.with_documents")}
                                                <span className="info__logo" />
                                            </>
                                        }
                                    />,
                                ]}
                            />
                        </div>
                    </FormRow>
                </>
            )}
        </>
    );
};

export default SearchExchange;
